"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var i0 = require("./term-of-use.component.scss.shim.ngstyle");
var i1 = require("@angular/core");
var i2 = require("./term-of-use.component");
var styles_TermOfUseComponent = [i0.styles];
var RenderType_TermOfUseComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_TermOfUseComponent, data: {} });
exports.RenderType_TermOfUseComponent = RenderType_TermOfUseComponent;
function View_TermOfUseComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "div", [["class", "container pt-2 pb-2"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, [" TERM OF USE "]))], null, null); }
exports.View_TermOfUseComponent_0 = View_TermOfUseComponent_0;
function View_TermOfUseComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-term-of-use", [], null, null, null, View_TermOfUseComponent_0, RenderType_TermOfUseComponent)), i1.ɵdid(1, 114688, null, 0, i2.TermOfUseComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_TermOfUseComponent_Host_0 = View_TermOfUseComponent_Host_0;
var TermOfUseComponentNgFactory = i1.ɵccf("app-term-of-use", i2.TermOfUseComponent, View_TermOfUseComponent_Host_0, {}, {}, []);
exports.TermOfUseComponentNgFactory = TermOfUseComponentNgFactory;
